/** Calendar domain storage. Colleague prefs + weekday flag are cross-tab (localStorage); the event-type filter is per-tab (sessionStorage). */
import Storage from '../index';
import StorageKeys from '../keys';

const calendar = {
    getSelectedColleagues: () => Storage.get(StorageKeys.calendarSelectedColleagues, null),

    // Persisting colleagues also records an explicit preference, so defaults are not re-applied on later loads.
    setSelectedColleagues: (ids) => {
        Storage.set(StorageKeys.calendarSelectedColleagues, Array.from(ids));
        Storage.setRaw(StorageKeys.calendarHasColleaguePreference, 'true');
    },

    hasColleaguePreference: () => Storage.getRaw(StorageKeys.calendarHasColleaguePreference) === 'true',

    getWeekdaysOnly: () => Storage.getRaw(StorageKeys.calendarWeekdaysOnly) === 'true',
    setWeekdaysOnly: (only) => Storage.setRaw(StorageKeys.calendarWeekdaysOnly, only ? 'true' : 'false'),

    getEventTypesState: (fallback = null) => Storage.get(StorageKeys.calendarEventTypesState, fallback),
    setEventTypesState: (state) => Storage.set(StorageKeys.calendarEventTypesState, state),
};

export default calendar;
